<template>
    <div class="publish-container">
      <!-- 返回按钮 -->
      <el-button
        type="text"
        icon="el-icon-arrow-left"
        class="back-button"
        @click="handleBack"
      >
        返回
      </el-button>
  
      <!-- 商品发布表单 -->
      <el-card class="form-card">
        <h2 class="title">发布商品</h2>
        <el-form
          :model="productForm"
          :rules="rules"
          ref="productForm"
          label-width="100px"
          label-position="left"
        >
          <!-- 商品名称 -->
          <el-form-item label="商品名称" prop="name">
            <el-input
              v-model="productForm.name"
              placeholder="请输入商品名称"
              clearable
            ></el-input>
          </el-form-item>
  
          <!-- 商品价格 -->
          <el-form-item label="商品价格" prop="price">
            <el-input
              v-model.number="productForm.price"
              placeholder="请输入商品价格"
              clearable
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
  
          <!-- 商品描述 -->
          <el-form-item label="商品描述" prop="description">
            <el-input
              type="textarea"
              :rows="4"
              v-model="productForm.description"
              placeholder="请输入商品描述"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
  
          <!-- 图片上传 -->
          <el-form-item label="商品图片" prop="images">
            <el-upload
              action="http://www.wjyzlj.cn/pet/file/uploads"  
              list-type="picture-card"
              :file-list="productForm.images"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
              :limit="6"
              :on-exceed="handleExceed"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
  
          <!-- 提交按钮 -->
          <el-form-item>
            <el-button type="primary" @click="submitForm('productForm')" size="medium">
              立即发布
            </el-button>
            <el-button @click="resetForm('productForm')" size="medium">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        productForm: {
          name: "",
          price: null,
          description: "",
          images: [],
        },
        dialogImageUrl: "",
        dialogVisible: false,
        rules: {
          name: [
            { required: true, message: "请输入商品名称", trigger: "blur" },
            { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" },
          ],
          price: [
            { required: true, message: "请输入商品价格", trigger: "blur" },
            { type: "number", message: "价格必须为数字", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (value <= 0) {
                  callback(new Error("价格必须大于0"));
                } else {
                  callback();
                }
              },
              trigger: "blur",
            },
          ],
          description: [
            { required: true, message: "请输入商品描述", trigger: "blur" },
            { min: 10, max: 300, message: "长度在 10 到 300 个字符", trigger: "blur" },
          ],
          images: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (this.productForm.images.length === 0) {
                  callback(new Error("请至少上传一张商品图片"));
                } else {
                  callback();
                }
              },
              trigger: "change",
            },
          ],
        },
      };
    },
    methods: {
      // 返回上一页
      handleBack() {
        this.$router.go(-1); // 返回上一页
      },
  
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 这里添加实际提交逻辑
            console.log("提交数据:", this.productForm);
            this.$message.success("商品发布成功！");
          } else {
            this.$message.error("请正确填写表单");
            return false;
          }
        });
      },
  
      // 重置表单
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.productForm.images = [];
      },
  
      // 图片上传处理
      handleRemove(file, fileList) {
        this.productForm.images = fileList;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleUploadSuccess(response, file, fileList) {
        this.productForm.images = fileList;
      },
      beforeUpload(file) {
        const isImage = file.type.includes("image/");
        const isLt5M = file.size / 1024 / 1024 < 5;
  
        if (!isImage) {
          this.$message.error("只能上传图片文件！");
        }
        if (!isLt5M) {
          this.$message.error("图片大小不能超过5MB！");
        }
        return isImage && isLt5M;
      },
      handleExceed() {
        this.$message.warning("最多只能上传6张图片");
      },
    },
  };
  </script>
  
  <style>
  .publish-container {
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    position: relative;
  }
  
  .back-button {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
  }
  
  .publish-container .form-card {
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .publish-container .title {
    text-align: center;
    color: #303133;
    margin-bottom: 30px;
    font-size: 24px;
  }
  
  .publish-container .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
  }
  
  .publish-container .el-upload-list__item {
    transition: all 0.3s ease;
  }
  
  @media (max-width: 768px) {
    .publish-container {
      padding: 10px;
    }
  
    .publish-container .form-card {
      padding: 15px;
    }
  }
  </style>